module.exports = __webpack_public_path__ + "static/achievement-3-7da5c1a3dce77f5087d904658ec8f2df.svg";